//profile action types
export const CREATE_PROFILE = 'CREATE_PROFILE';
export const FETCH_PROFILES = 'FETCH_PROFILES';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const DELETE_PROFILE = 'DELETE_PROFILE';
export const COLLECT_PROFILE_DATA = 'COLLECT_PROFILE_DATA';
export const START_FETCH_USER_PROFILE = 'START_FETCH_USER_PROFILE';
export const SUCCESS_FETCH_USER_PROFILE = 'SUCCESS_FETCH_USER_PROFILE';
export const ERROR_FETCH_USER_PROFILE = 'ERROR_FETCH_USER_PROFILE';

//profile prompt action types
export const ADD_PROFILE_PROMPTS = 'ADD_PROFILE_PROMPTS';
export const UPDATE_PROFILE_PROMPT = 'UPDATE_PROFILE_PROMPT';

//interest action types
export const ADD_PROFILE_INTEREST = 'ADD_PROFILE_INTEREST';
export const REMOVE_PROFILE_INTEREST = 'REMOVE_PROFILE_INTEREST';

//virtue action types
export const RESET_VIRTUE = 'RESET_VIRTUE';
export const NEXT_VIRTUE = 'NEXT_VIRTUE';
export const PREVIOUS_VIRTUE = 'PREVIOUS_VIRTUE';

//profile photo action types
export const ADD_PROFILE_PHOTO = 'ADD_PROFILE_PHOTO';
export const REMOVE_PROFILE_PHOTO = 'REMOVE_PROFILE_PHOTO';

//preference filter types
export const PREFERENCE_FILTERS_UPDATE = 'PREFERENCE_FILTERS_UPDATE';

//couple action types
export const UNMATCH_COUPLE = 'UNMATCH_COUPLE';

//message action types
export const ADD_INTERESTED_IN_YOU = 'ADD_INTERESTED_IN_YOU';
export const SHOW_INTERESTED_IN_YOU = 'SHOW_INTERESTED_IN_YOU';
export const FETCH_MESSAGE_ROOM_MESSAGES = 'FETCH_MESSAGE_ROOM_MESSAGES';
export const MESSAGE_SENT = 'MESSAGE_SENT';

//authentication action types
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_CHANGE_PASSWORD = 'AUTH_CHANGE_PASSWORD';
export const AUTH_FORGOT_PASSWORD = 'AUTH_FORGOT_PASSWORD';